export const ID = 'id';
export const NAME = 'name';
export const APPLICATIONS = 'applications';
export const INTERNAL_TAGS = 'internalTags';
export const AI_TAGS = 'aiTags';
export const IS_THUMBNAIL_GENERATING = 'isThumbnailGenerating';
export const AI_GENERATED = 'isAICreated';

export const REPLAI_TAGS = 'replaiTags';
export const ALISON_TAGS = 'alisonTags';
export const REQUESTED_BY = 'requestedBy';
export const JIRA_TASK = 'jiraTask';
export const DESCRIPTION = 'description';

export const START_DATE = 'startDate';
export const EXPIRATION_DATE = 'expirationDate';
export const UNARCHIVE_DATE = 'unarchiveDate';
export const STATUS_UPDATE_DATE = 'statusUpdateDate';

export const ORIGINAL = 'original';
export const ORIGINAL_ID = 'originalId';
export const FILE = 'file';
export const HAS_STATS = 'hasStats';
export const USED_IN_AFFILIATES = 'affiliates';
export const EXCLUSIVE_FOR_AFFILIATES = 'exclusiveForAffiliates';

export const COMMENTS = 'comments';
export const REVIEWS = 'reviews';

export const UPDATED_BY = 'updatedBy';
export const UPDATED_DATE = 'updatedDate';
export const CREATED_BY = 'createdBy';
export const CREATED_DATE = 'createdDate';
export const MOVED_CREATIVES = 'movedCreatives';
export const STATUS_ID = 'statusId';
export const STATE_SCHEDULES = 'stateSchedules';
export const CREATIVES_COUNT = 'creativesCount';
export const COMMENTS_COUNT = 'commentsCount';
export const RATING = 'rating';
export const CONCEPT_FAMILIES = 'conceptFamilies';
export const IS_SHARED = 'isShared';
export const SHARED_WITH = 'sharedWith';
export const BUSINESS_PARTNERS = 'businessPartners';
export const PROMO_CODE = 'promoCode';

export const SHARE_COUNT = 'shareCount';
export const IS_PARTIAL_SHARED = 'isPartialShared';
export const IS_NEW = 'isNew';
export const ACTIONS = 'actions';
